<section class="events-bet-type-groups">
    <!-- <div class="buttons-wrap">
        <div class="btn small outline-primary" [class.selected]="betTypeGroup.id == selectedBetTypeGrupId" (click)="selectBetTypeGroup(betTypeGroup)" *ngFor="let betTypeGroup of betTypeGroups">{{betTypeGroup.name}}</div>
    </div> -->

  <!--<div class="bet-type-wrap" *ngIf="selectedBetTypeGroup">
      <div class="btn small outline-light" [class.selected]="betTypeGroupingTemplateItem.id === selectedBetTypeGroupingTemplateItem1?.id || betTypeGroupingTemplateItem.id === selectedBetTypeGroupingTemplateItem2?.id || betTypeGroupingTemplateItem.id === selectedBetTypeGroupingTemplateItem3?.id "
      (click)="selectBetTypeGroupingTemplateItem(betTypeGroupingTemplateItem)" *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems; let i = index">
          {{betTypeGroupingTemplateItem.betTypeName}}
      </div>
  </div> -->
    <ng-container *ngIf="betTypeGroups.length > 0">
      <select name="betTypeGroup" class="form-control form-control-sm" id="betTypeGroup" (change)="selectBetTypeGroupById($event.target.value)">
        <option value="{{betTypeGroup.id}}"
        [selected]="betTypeGroup.id == selectedBetTypeGrupId"
        *ngFor="let betTypeGroup of betTypeGroups">{{betTypeGroup.name | titlecase }}</option>
      </select>
    </ng-container>
    <ng-container *ngIf="selectedBetTypeGroup && ((isMobileView && selectedBetTypeGroup.betTypeGroupingTemplateItems.length > 0) || selectedBetTypeGroup.betTypeGroupingTemplateItems.length > 2)">
      <select name="betTypeName" class="form-control form-control-sm" id="betTypeName" (change)="selectBetTypeGroupingTemplateItemById($event.target.value)">
        <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems;">
          <option
            *ngIf="isMobileView || betTypeGroupingTemplateItem.id != selectedBetTypeGroupingTemplateItem1?.id && betTypeGroupingTemplateItem.id != selectedBetTypeGroupingTemplateItem2?.id"
            value="{{betTypeGroupingTemplateItem.id}}"
            [selected]="(!isMobileView && betTypeGroupingTemplateItem.id === selectedBetTypeGroupingTemplateItem3?.id) || (isMobileView && betTypeGroupingTemplateItem.id === selectedBetTypeGroupingTemplateItem1?.id)">
            {{betTypeGroupingTemplateItem.betTypeName}}</option>
        </ng-container>
      </select>
    </ng-container>
</section>
